import React from 'react';
import { Card, Form, Input, Select, Row, Col, Space, Button, DatePicker, InputNumber } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import Calendar from '../svg/Calendar';
import CurvDown from '../svg/CurvDown';

const { Option } = Select;

interface AgeProps {
  form: FormInstance;
  isViewMode?: boolean;
}

const Age: React.FC<AgeProps> = ({ form, isViewMode }) => {
  const isView = isViewMode || new URLSearchParams(window.location.search).get('view') === 'true';
  const yesNoOptions = ['Yes', 'No'];

  return (
    <div className="flex flex-col w-full h-full">
      <FormSection title="Age Information" columns={1} className="age-section">
        <style dangerouslySetInnerHTML={{
          __html: `
          .age-section .ant-form-item-label {
            min-height: 58px !important;
            margin-bottom: 8px !important;
            display: flex !important;
            align-items: flex-end !important;
            line-height: 1.2 !important;
          }
          @media (max-width: 767px) {
            .age-section .ant-form-item-label {
              min-height: 20px !important;
              display: block !important;
            }
          }
          .age-section .ant-select-selector,
          .age-section .ant-input,
          .age-section .ant-picker {
            padding-left: 19px !important;
            padding-right: 19px !important;
          }
        `}} />
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-[60px] gap-y-[16px] w-full">
          <Form.Item
            label="Your DOB"
            name={['age_info', 'your_dob']}
            className="mb-0"
          >
            <DatePicker
              placeholder="Select Date"
              format="DD-MM-YYYY"
              suffixIcon={<Calendar />}
              className="w-full"
              inputReadOnly
            />
          </Form.Item>

          <Form.Item
            label="Accused's DOB (if know)"
            name={['age_info', 'accused_dob']}
            className="mb-0"
          >
            <DatePicker
              placeholder="Select Date"
              format="MM-DD-YYYY"
              suffixIcon={<Calendar />}
              className="w-full"
              inputReadOnly
            />
          </Form.Item>

          <Form.Item
            label="Is one or more of your coworkers younger than you?"
            name={['age_info', 'coworkers_younger']}
            className="mb-0"
          >
            <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </div >

        <div className="col-span-1 md:col-span-3 mt-[8px] md:mt-[26px]">
          <Form.List name={['age_info', 'other_employees']}>
            {(fields, { add, remove }) => (
              <>
                <div className="flex items-center justify-between mb-4 w-full md:w-[70%] gap-[34px] md:gap-0">
                  <h3 className="font-['Lexend',sans-serif] text-[14px] lg:text-[18px] font-medium text-[#1F2A37] leading-[29px] m-0">
                    Other employees estimated age and DOB's (if known)
                  </h3>
                  <Button
                    type="text"
                    // onClick={() => {
                    //   const employees = form.getFieldValue(['age_info', 'other_employees']) || [];
                    //   if (employees.length < 3) {
                    //     if (employees.length > 0) {
                    //       form.validateFields([['age_info', 'other_employees', employees.length - 1]])
                    //         .then(() => form.setFieldValue(['age_info', 'other_employees'], [...employees, {}]))
                    //         .catch(() => {});
                    //     } else {
                    //       form.setFieldValue(['age_info', 'other_employees'], [{}]);
                    //     }
                    //   }
                    // }}
                    // disabled={form.getFieldValue(['age_info', 'other_employees'])?.length >= 3}
                    htmlType="button"
                    onClick={() => add()}
                    disabled={fields.length >= 3 || isViewMode}
                    className="flex items-center gap-2 text-[#4682B4] font-['Lexend',sans-serif] p-0 disabled:opacity-50"
                  >
                    <span className="text-[18px] text-[#4682B4] leading-none">+</span> Add More
                  </Button>
                </div>


                <div className="flex flex-col gap-0 w-full lg:w-[70%]">
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key} className="flex flex-row items-start w-full mb-4">
                      {/* Number */}
                      <div className="w-8 flex justify-center pt-[50px] md:pt-[75px] mr-[8px] md:mr-[18px]">
                        <span className="font-['Lexend',sans-serif] text-[12px] md:text-[18px] text-[#1F2A37A1] font-medium">
                          {String(name + 1).padStart(2, '0')}
                        </span>
                      </div>

                      {/* Age Input */}
                      <div className="flex-1 mr-[20px] md:mr-[60px]">
                        <Form.Item
                          {...restField}
                          name={[name, 'age']}
                          label={name === 0 ? "Age" : <span className="select-none">Age</span>}
                          className="mb-0"
                          rules={[{ required: true, message: 'Please enter age' }]}
                        >
                          <InputNumber
                            placeholder="Age"
                            className="w-full"
                            controls={false}
                            onKeyDown={(e) => {
                              if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Form.Item>
                      </div>

                      {/* DOB Picker */}
                      <div className="flex-1 mr-[10px] md:mr-[31px]">
                        <Form.Item
                          {...restField}
                          name={[name, 'dob']}
                          label={name === 0 ? "DOB" : <span className="select-none">DOB</span>}
                          className="mb-0"
                          rules={[{ required: true, message: 'Please select DOB' }]}
                        >
                          <DatePicker
                            placeholder="Select Date"
                            format="MM-DD-YYYY"
                            suffixIcon={<Calendar />}
                            className="w-full"
                            inputReadOnly
                          />
                        </Form.Item>
                      </div>

                      {/* Delete Action */}
                      <div className="w-10 flex justify-center pt-[50px] md:pt-[75px]">
                        <button
                          onClick={() => {
                            if (!isView) {
                              remove(name);
                            }
                          }}
                          disabled={isView}
                          type="button"
                          style={isView ? { pointerEvents: 'none', opacity: 0.3, cursor: 'not-allowed' } : undefined}
                          className="p-1 text-[#6FB6F2] hover:text-red-500 transition-colors border-none bg-transparent cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                        >
                          <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="md:w-[18px] md:h-[20px] w-[12px] h-[13px] stroke-current">
                            <path d="M1 4h14M2 4v11a2 2 0 002 2h8a2 2 0 002-2V4M5 4V2a1 1 0 011-1h4a1 1 0 011 1v2M6.5 8v5M9.5 8v5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

          </Form.List>
        </div>
      </FormSection>
    </div>
  );
};

export default Age;
